import { AbstractPmsApiService } from './abstract.service';
import { ReservationActivity } from '../models';

/**
 * @class ReservationActivityPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ReservationActivity>}
 */
export class ReservationActivityPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/reservation/:reservationId/activity(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @param params
     * @returns {ReservationActivity}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ReservationActivity(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Reservation=} reservation
     * @returns {Promise.<PaginationCollection<ReservationActivity>>}
     */
    get(params = {}, reservation) {
        
        const url = this.url({
            reservationId: reservation.id
        });
        
        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

}



// WEBPACK FOOTER //
// ./src/pms-api/services/reservation-activity.service.js